import React from 'react'
import { useTranslation } from 'react-i18next'

import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import StockItemLoader from './_load/StockItemLoader'
import { TabsContext } from '../../../packages/kiti/components/tabs/TabsContext'
import { HorizontalLine } from '../../../components/shapes/Line'
import { COLORS } from '@btime/constants'
import UserStocks from './userStocks/UserStocks'
import TransfersHistory from './transfersHistory/TransfersHistory'
import Details from './details/Details'
import TabsContent from '../../../packages/kiti/components/tabs/TabsContent'
import { useSessionPermission } from '@btime/react-session'
import Qrcodes from './tabs/Qrcodes'
import PlaceStocks from './placeStocks/PlaceStocks'

const StockItemDetailModal = props => {
  const { t } = useTranslation('listStocks')
  const shouldShowQRCodeTab = useSessionPermission('showQRCodeOnModalDetails')

  const tabsOptions = [
    { name: t('tabs.details'), render: () => <Details /> },
    { name: t('tabs.transfersHistory'), render: () => <TransfersHistory /> },
    { name: t('tabs.userStocks'), render: () => <UserStocks /> },
    { name: t('tabs.placeStocks'), render: () => <PlaceStocks /> },
    { name: t('tabs.qrCodes'), render: () => <Qrcodes />, notShow: !shouldShowQRCodeTab }
  ]

  return (
    <ControlledModal width="50rem" {...props}>
      <StockItemLoader>
        <TabsContext options={tabsOptions}>
          <ModalHeader />

          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />
          <TabsContent />
        </TabsContext>
      </StockItemLoader>
    </ControlledModal>
  )
}

export default StockItemDetailModal
